// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"styles_messageContainer__1pkJ3","buttonContainer":"styles_buttonContainer__3qzBq","confirm":"styles_confirm__BIOAh","cancel":"styles_cancel__1Do59"};